/**
 * 获取 MQTT WebSocket 连接地址。
 * - 生产（Docker）：走 nginx 反代，同域 /mqtt 路径
 * - 开发：走 Vite 代理，同域 /mqtt 路径
 * - 显式设置 VITE_MQTT_BROKER_URL 时直接使用（优先）
 */
export function getMqttBrokerUrl(): string {
  const envUrl = import.meta.env.VITE_MQTT_BROKER_URL as string | undefined
  if (envUrl) return envUrl
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${proto}//${window.location.host}/mqtt`
}
